module.exports = __webpack_public_path__ + "img/icon_question.5bad25dd.svg";